<template>
  <component 
    :is="component"
    :href="url" 
    :other="other" 
    :target="blank">
    <slot></slot>
  </component>
</template>
<script>

export default {
  name:'ALink',
  data(){
    return{
      blank:'_self'
    }
  },
  props:{
    href:{
      type:String
    },
    other:{
      type:Boolean,
      default:false
    }
  },
  computed:{
    url(){
      if(this.other){
        this.blank = '_blank';
        return this.href;
      }
      return this.href+".html"
    },
    component(){
      if(this.href){
        return 'a'
      }else{
        return 'span'
      }
    }
  }
};
</script>

